import { FC } from "react";
import { Box, Flex, Heading, Text } from "@smile2impress/components/relaunch";
import { Picture } from "@smile2impress/components";

import { ImageCardProps } from "./ImageCard.types";

const CARD_GRADIENT =
    "linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.7) 94%)";

export const ImageCard: FC<ImageCardProps> = ({ title, text, bg }) => {
    return (
        <Box
            position="relative"
            flex={1}
            minH={["360px", "480px", "596px"]}
            borderRadius="sm"
            overflow="hidden"
            role="article"
            aria-label={title}
        >
            <Box position="absolute" inset={0}>
                <Picture
                    {...bg}
                    width="100%"
                    height="100%"
                    imageProps={{
                        objectFit: "cover",
                        objectPosition: "center center",
                        width: "100%",
                        height: "100%",
                    }}
                />
            </Box>

            <Box
                aria-hidden
                position="absolute"
                inset={0}
                bg={CARD_GRADIENT}
                pointerEvents="none"
            />

            <Flex
                position="absolute"
                inset={0}
                zIndex={1}
                direction="column"
                justifyContent="flex-end"
                p={[2, 2, 3]}
                gap={[1]}
            >
                <Heading
                    textStyle={["title1", "title1", "title1"]}
                    color="text.baseInverse"
                    mb={0}
                >
                    {title}
                </Heading>
                <Text
                    textStyle={["body", "body", "body"]}
                    color="text.baseInverse"
                    mb={0}
                    whiteSpace="pre-wrap"
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            </Flex>
        </Box>
    );
};
